import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_RATE_MANAGER } from '../redux/constants/rolesConstants';
import RatesHeader from '../components/rates/RatesHeader';
import RatesList from '../components/rates/RatesList';
import RatesPagination from '../components/rates/RatesPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Rates = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_RATE_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Оцінки вартості'} />
        </PageTitleContainer>
        <Container>
          <RatesHeader readOnly={readOnly} />
          <RatesList readOnly={readOnly} />
          <RatesPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Rates;
